import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';

export type FeatureServicePlanItemDetailsClasses = 'headerItem' | 'totalContainer' | 'totalLabel' | 'totalValue';

const featureServicePlanItemDetailsStyles = makeStyles<ISpcTheme, FeatureServicePlanItemDetailsClasses>(
  theme => ({
    headerItem: {
      fontFamily: theme.typography.fontFamily2,
    },
    totalContainer: {
      marginTop: '10px',
      paddingTop: '20px',
      display: 'flex',
      justifyContent: 'space-between',
      borderTop: `1px solid ${theme.palette.text.disabled}`,
    },
    totalLabel: {
      textTransform: 'uppercase',
      fontFamily: theme.typography.fontFamily2,
    },
    totalValue: {
      fontFamily: theme.typography.fontFamily2,
      fontSize: theme.typography.fontMD,
    },
  }),
  { name: 'Customise_Feature_ServicePlanItemDetails' },
);

export default featureServicePlanItemDetailsStyles;
